import { render } from "./EntraTenantSettings.vue?vue&type=template&id=b8d3fd5e&scoped=true"
import script from "./EntraTenantSettings.vue?vue&type=script&lang=js"
export * from "./EntraTenantSettings.vue?vue&type=script&lang=js"

import "./EntraTenantSettings.vue?vue&type=style&index=0&id=b8d3fd5e&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d3fd5e"]])

export default __exports__